"use strict";
exports["-58762533"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizTeamsMTRDeviceSignInTitle","description":"WizTeamsMTRDeviceSignInDesc","properties":{"oAuthCredential":{"type":"object","title":"GlobalAdminOAuthCredentialsLabel"},"userEmailAddress":{"type":"string","title":"LabelSpecifyMTRUPN","pattern":"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"},"deviceType":{"type":"number","title":"LabelDeviceSelection","default":1,"enum":[1,2,3],"enumNames":["LabelMTRAndroidDevice","LabelMTRWindowsDevice","LabelMTRPanelDevice"]},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription"}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["oAuthCredential","userEmailAddress","deviceType","notice","proofOfWork"],"$id":"-58762533"};
const pattern0 = new RegExp("^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-58762533" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.oAuthCredential === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "oAuthCredential"},message:"must have required property '"+"oAuthCredential"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.userEmailAddress === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "userEmailAddress"},message:"must have required property '"+"userEmailAddress"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.deviceType === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "deviceType"},message:"must have required property '"+"deviceType"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.notice === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.proofOfWork === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.oAuthCredential !== undefined){
let data0 = data.oAuthCredential;
if(!(data0 && typeof data0 == "object" && !Array.isArray(data0))){
const err5 = {instancePath:instancePath+"/oAuthCredential",schemaPath:"#/properties/oAuthCredential/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.oAuthCredential.type,parentSchema:schema11.properties.oAuthCredential,data:data0};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.userEmailAddress !== undefined){
let data1 = data.userEmailAddress;
if(typeof data1 === "string"){
if(!pattern0.test(data1)){
const err6 = {instancePath:instancePath+"/userEmailAddress",schemaPath:"#/properties/userEmailAddress/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"},message:"must match pattern \""+"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"+"\"",schema:"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$",parentSchema:schema11.properties.userEmailAddress,data:data1};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/userEmailAddress",schemaPath:"#/properties/userEmailAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.userEmailAddress.type,parentSchema:schema11.properties.userEmailAddress,data:data1};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.deviceType !== undefined){
let data2 = data.deviceType;
if(!(typeof data2 == "number")){
const err8 = {instancePath:instancePath+"/deviceType",schemaPath:"#/properties/deviceType/type",keyword:"type",params:{type: "number"},message:"must be number",schema:schema11.properties.deviceType.type,parentSchema:schema11.properties.deviceType,data:data2};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!(((data2 === 1) || (data2 === 2)) || (data2 === 3))){
const err9 = {instancePath:instancePath+"/deviceType",schemaPath:"#/properties/deviceType/enum",keyword:"enum",params:{allowedValues: schema11.properties.deviceType.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.deviceType.enum,parentSchema:schema11.properties.deviceType,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.notice !== undefined){
let data3 = data.notice;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.testAccountConsent === undefined){
const err10 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data3.testAccountConsent !== undefined){
let data4 = data3.testAccountConsent;
if(typeof data4 !== "boolean"){
const err11 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data4};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data3};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data5 = data.proofOfWork;
if(typeof data5 !== "string"){
const err13 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data5};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}
